/**
 * Quick Add Modal Component
 * Modern high-converting Quick Buy / Quick View Modal for Sand Agro
 */

if (!customElements.get('quick-add-modal')) {
  const BaseModalDialog = (typeof ModalDialog !== 'undefined'
    ? ModalDialog
    : (window.ModalDialog || customElements.get('modal-dialog') || class extends HTMLElement {}));

  customElements.define('quick-add-modal', class QuickAddModal extends BaseModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      
      const closeBtn = this.querySelector('.quick-add-modal__toggle, [id^="ModalClose-"]');
      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.hide(false);
        });
      }

      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });

      this.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    connectedCallback() {
      if (super.connectedCallback) {
        try { super.connectedCallback(); } catch(e) {}
      }
      const closeBtn = this.querySelector('.quick-add-modal__toggle, [id^="ModalClose-"]');
      if (closeBtn && !closeBtn._hasClickListener) {
        closeBtn._hasClickListener = true;
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.hide(false);
        });
      }
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification && this.openedBy) {
        try { cartNotification.setActiveElement(this.openedBy); } catch(e) {}
      }

      if (this.modalContent) {
        this.modalContent.innerHTML = '';
      }

      if (preventFocus) this.openedBy = null;
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');

      if (typeof super.hide === 'function') {
        try { super.hide(); } catch(e) {}
      }
    }

    show(opener) {
      this.openedBy = opener;
      opener.setAttribute('aria-disabled', 'true');
      opener.classList.add('loading');

      const spinner = opener.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const productUrl = opener.getAttribute('data-product-url');
      if (!productUrl) {
        opener.removeAttribute('aria-disabled');
        opener.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        return;
      }

      fetch(productUrl)
        .then((response) => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const sectionEl = responseHTML.querySelector('section[id^="MainProduct-"]') || responseHTML.querySelector('.main-product-template');
          const sectionId = sectionEl ? (sectionEl.dataset.section || sectionEl.id.replace('MainProduct-', '')) : null;
          
          // Extract specific product info container to avoid full-page margins/padding
          const mainInfo = responseHTML.querySelector('.main-product_info');
          this.productElement = mainInfo || sectionEl;

          if (!this.productElement) {
            console.error('Could not locate product section in fetched HTML');
            return;
          }

          this.preventDuplicatedIDs(sectionId);        
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.outerHTML || this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            try { window.ProductModel.loadShopifyXR(); } catch(e) {}
          }

          this.removeGalleryListSemantic();         
          this.preventVariantURLSwitching();
          this.initGalleryThumbnails();
          this.initQuantitySteppers();
          this.restructureLayout();
          this.appendTrustBadges();

          if (typeof DTWishlist === 'function') {
            try { DTWishlist(); } catch(e) {}
          }

          // Show modal
          document.body.classList.add('overflow-hidden');
          this.setAttribute('open', '');

          if (typeof super.show === 'function') {
            try { super.show(opener); } catch(e) {}
          }
        })
        .catch((error) => {
          console.error('Quick view error:', error);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');                    
        });           
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Re-executes inline scripts so Shopify variants and payment forms bind
      element.querySelectorAll('script').forEach((oldScriptTag) => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });      
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios, variant-selects');
      if (!variantPicker) return;      
      variantPicker.setAttribute('data-update-url', 'false');      

      if (window.jQuery) {
        $('input:radio[name="Color"]').off('click.quickadd').on('click.quickadd', function() {      
          $('input:radio[name="Color"]').next('.swatch-element').removeClass('clicked');
          $(this).next('.swatch-element').addClass('clicked');
        });
      }
    }

    removeDOMElements() {
      if (!this.productElement) return;

      const selectorsToRemove = [
        'pickup-availability',
        'product-modal',
        'enquiryPopUp',
        'modal-dialog',
        '.prev-next-product-navigation',
        '.dt-zoom-detail',
        '.breadcrumb-main-template',
        '.product__info-as-bottom-tabs',
        '.product-deal-count',
        '.share-button',
        '.html-sections-product',
        '.product__view-details',
        '.product__payment',
        '.secure-badges',
        '.product-form-installment',
        '.dT_VProdCompareList',
        '.rating-fake-sales',
        '.inventory--progress',
        '.product__inventory',
        '[id^="Inventory-"]',
        '.inventory-form__label',
        '.availablity-stack',
        '.product__sku',
        '.sku',
        '[class*="product__sku"]',
        '.product-attributes',
        'hr',
        '.toggleFilter',
        'aside'
      ];

      selectorsToRemove.forEach((sel) => {
        const els = this.productElement.querySelectorAll(sel);
        els.forEach((el) => el.remove());
      });
    }

    preventDuplicatedIDs(sectionId) {
      if (!this.productElement) return;
      const secId = sectionId || this.productElement.dataset.section;
      if (secId) {
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(secId, `quickadd-${ secId }`);
        this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
          variantSelect.dataset.originalSection = secId;
        });      
      }
    }

    removeGalleryListSemantic() {      
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');      
      if (galleryList) {
        galleryList.setAttribute('role', 'presentation');
        galleryList.classList.remove('grid--peek', 'two-column', 'slider', 'slider--mobile', 'grid');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => {
          li.setAttribute('role', 'presentation');
          li.classList.remove('grid__item', 'slider__slide');
        });
      }

      const FBT = this.modalContent.querySelector('[id^="dT_bundleSelector"]');        
      if (FBT) FBT.remove();
      const Tabs = this.modalContent.querySelector('[class*="product__info-as-bottom-tabs"]');
      if (Tabs) Tabs.remove();
      this.modalContent.querySelectorAll('.slider-button, .slider-buttons').forEach(el => el.remove());
    }

    initGalleryThumbnails() {
      const modal = this.modalContent;
      const thumbnails = Array.from(modal.querySelectorAll('.thumbnail-list__item, [data-target]'));
      const mainSlides = Array.from(new Set(modal.querySelectorAll('.product__media-item')));

      if (!thumbnails.length || !mainSlides.length) return;

      // Activate first main image initially
      mainSlides.forEach((slide, idx) => {
        if (idx === 0) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });

      // Wrap thumbnail list into a horizontal single-row carousel with prev/next arrows
      const thumbList = modal.querySelector('.thumbnail-list');
      if (thumbList && !modal.querySelector('.quick-add-thumb-carousel')) {
        const carousel = document.createElement('div');
        carousel.className = 'quick-add-thumb-carousel';

        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'quick-add-thumb-arrow quick-add-thumb-prev';
        prevBtn.setAttribute('aria-label', 'Previous image');
        prevBtn.innerHTML = `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>`;

        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'quick-add-thumb-arrow quick-add-thumb-next';
        nextBtn.setAttribute('aria-label', 'Next image');
        nextBtn.innerHTML = `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>`;

        const track = document.createElement('div');
        track.className = 'quick-add-thumb-track';

        thumbList.parentNode.insertBefore(carousel, thumbList);
        track.appendChild(thumbList);
        carousel.appendChild(prevBtn);
        carousel.appendChild(track);
        carousel.appendChild(nextBtn);

        let currentIndex = 0;

        const selectThumb = (index) => {
          if (index < 0) index = thumbnails.length - 1;
          if (index >= thumbnails.length) index = 0;
          currentIndex = index;

          thumbnails.forEach((t, i) => {
            const b = t.querySelector('button') || t;
            if (i === currentIndex) {
              b.setAttribute('aria-current', 'true');
              t.classList.add('is-active');
              t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            } else {
              b.removeAttribute('aria-current');
              t.classList.remove('is-active');
            }
          });

          const activeThumb = thumbnails[currentIndex];
          const targetId = activeThumb.getAttribute('data-target');

          let matched = false;
          mainSlides.forEach((slide) => {
            const slideMediaId = slide.getAttribute('data-media-id');
            if (slideMediaId && targetId && (slideMediaId === targetId || slideMediaId.endsWith(targetId) || targetId.endsWith(slideMediaId))) {
              slide.classList.add('is-active');
              matched = true;
            } else {
              slide.classList.remove('is-active');
            }
          });

          if (!matched && mainSlides[currentIndex]) {
            mainSlides.forEach((s, idx) => {
              if (idx === currentIndex) {
                s.classList.add('is-active');
              } else {
                s.classList.remove('is-active');
              }
            });
          }
        };

        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          selectThumb(currentIndex - 1);
        });

        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          selectThumb(currentIndex + 1);
        });

        // Hide arrows if only 4 or fewer thumbnails
        if (thumbnails.length <= 4) {
          carousel.classList.add('no-nav-needed');
        }

        // Bind thumbnail clicks
        thumbnails.forEach((thumb, idx) => {
          thumb.addEventListener('click', (e) => {
            e.preventDefault();
            selectThumb(idx);
          });
        });

        selectThumb(0);
      }
    }

    initQuantitySteppers() {
      // Standard Shopify <quantity-input> elements in global.js already attach click handlers to stepUp/stepDown.
      // Attaching duplicate click handlers causes quantity to skip numbers (1 -> 3 -> 5).
      // We only attach custom listeners if the quantity wrapper is NOT a <quantity-input> custom element.
      const qtyInputs = this.modalContent.querySelectorAll('.quantity:not(quantity-input)');
      qtyInputs.forEach((qty) => {
        if (qty.tagName.toLowerCase() === 'quantity-input' || qty.closest('quantity-input')) return;
        const minus = qty.querySelector('[name="minus"], .quantity__button[name="minus"], button:first-of-type');
        const plus = qty.querySelector('[name="plus"], .quantity__button[name="plus"], button:last-of-type');
        const input = qty.querySelector('input[type="number"], .quantity__input');
        if (!input) return;

        if (minus && !minus._hasCustomListener) {
          minus._hasCustomListener = true;
          minus.addEventListener('click', (e) => {
            e.preventDefault();
            const val = parseInt(input.value) || 1;
            if (val > 1) {
              input.value = val - 1;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }

        if (plus && !plus._hasCustomListener) {
          plus._hasCustomListener = true;
          plus.addEventListener('click', (e) => {
            e.preventDefault();
            const val = parseInt(input.value) || 1;
            input.value = val + 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
      });
    }

    restructureLayout() {
      const modal = this.modalContent;
      const form = modal.querySelector('form.form, form[action*="/cart/add"], product-form form');
      if (!form) return;

      // 1. Locate Quantity and Wishlist
      const qtyWrapper = modal.querySelector('.product-form__input--quantity, quantity-input')?.closest('.product-form__input--quantity') 
        || modal.querySelector('.product-form__input--quantity') 
        || modal.querySelector('quantity-input');
      const wishlistBtn = modal.querySelector('.dT_VProdWishList') || modal.querySelector('.comp-wish .dT_VProdWishList');
      const submitBtn = modal.querySelector('.product-form__submit, button[name="add"]');
      const dynamicCheckout = modal.querySelector('.shopify-payment-button');

      // Create Quantity + Wishlist Row
      if (!modal.querySelector('.quick-add-qty-wish-row') && (qtyWrapper || wishlistBtn)) {
        const qtyRow = document.createElement('div');
        qtyRow.className = 'quick-add-qty-wish-row';
        
        const qtyLabel = document.createElement('span');
        qtyLabel.className = 'quick-add-qty-label';
        qtyLabel.textContent = 'Quantity :';
        qtyRow.appendChild(qtyLabel);

        if (qtyWrapper) {
          const oldLabel = qtyWrapper.querySelector('.form__label');
          if (oldLabel) oldLabel.remove();
          qtyRow.appendChild(qtyWrapper);
        }

        if (wishlistBtn) {
          const wishContainer = document.createElement('div');
          wishContainer.className = 'quick-add-wish-wrapper';
          wishContainer.appendChild(wishlistBtn);
          qtyRow.appendChild(wishContainer);
        }

        form.insertBefore(qtyRow, form.firstChild);
      }

      // Create Dual Action Buttons Row
      if (!modal.querySelector('.quick-add-cta-row') && submitBtn) {
        const ctaRow = document.createElement('div');
        ctaRow.className = 'quick-add-cta-row';

        // Add shopping bag icon to Add To Cart button
        if (!submitBtn.querySelector('.quick-add-bag-icon')) {
          const bagIcon = document.createElement('span');
          bagIcon.className = 'quick-add-bag-icon';
          bagIcon.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>`;
          submitBtn.insertBefore(bagIcon, submitBtn.firstChild);
        }
        ctaRow.appendChild(submitBtn);

        if (dynamicCheckout) {
          ctaRow.appendChild(dynamicCheckout);
        }

        // Clean up empty containers
        const oldBtns = modal.querySelector('.product-form__buttons');
        if (oldBtns && oldBtns !== ctaRow) oldBtns.remove();
        const oldCompWish = modal.querySelector('.comp-wish');
        if (oldCompWish) oldCompWish.remove();

        form.appendChild(ctaRow);
      }
    }

    appendTrustBadges() {
      const infoContainer = this.modalContent.querySelector('.product__info-container') 
        || this.modalContent.querySelector('.product__info-wrapper');
      if (!infoContainer) return;

      // Ensure tax & shipping text is standardized
      const taxEl = this.modalContent.querySelector('.product__tax');
      if (taxEl) {
        taxEl.textContent = 'Tax included. Shipping calculated at checkout.';
      }

      // Add subtitle tag if missing
      const titleEl = infoContainer.querySelector('.product__title');
      if (titleEl && !infoContainer.querySelector('.quick-add-rituals-tag')) {
        const ritualTag = document.createElement('div');
        ritualTag.className = 'quick-add-rituals-tag';
        ritualTag.textContent = 'SAND AGRO';
        titleEl.parentNode.insertBefore(ritualTag, titleEl);
      }

      if (infoContainer.querySelector('.quick-add-trust-badges')) return;

      // Add trust badges box (FSSAI Compliant - No restricted health/purity claims)
      const badges = document.createElement('div');
      badges.className = 'quick-add-trust-badges';
      badges.innerHTML = `
        <div class="quick-add-badge-item">
          <div class="badge-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#466732" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              <path d="m9 12 2 2 4-4"></path>
            </svg>
          </div>
          <div class="badge-text">
            <strong>Quality Assured</strong>
            <span>Carefully Packed</span>
          </div>
        </div>
        <div class="quick-add-badge-item">
          <div class="badge-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#466732" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"></path>
              <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>
            </svg>
          </div>
          <div class="badge-text">
            <strong>Handcrafted</strong>
            <span>Small Batches</span>
          </div>
        </div>
        <div class="quick-add-badge-item">
          <div class="badge-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#466732" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path>
              <path d="M15 18H9"></path>
              <path d="M19 18h2a1 1 0 0 0 1-1v-5.28a2 2 0 0 0-.6-1.42l-2.4-2.4a2 2 0 0 0-1.4-.6H14v10.7"></path>
              <circle cx="7" cy="18" r="2"></circle>
              <circle cx="17" cy="18" r="2"></circle>
            </svg>
          </div>
          <div class="badge-text">
            <strong>Fast Delivery</strong>
            <span>3-5 Days</span>
          </div>
        </div>
      `;

      const form = this.modalContent.querySelector('form.form, form[action*="/cart/add"], product-form form');
      if (form && form.parentNode) {
        form.parentNode.insertBefore(badges, form.nextSibling);
      } else {
        infoContainer.appendChild(badges);
      }

      // Purge any residual elements after trust badges in the container
      const badgesEl = infoContainer.querySelector('.quick-add-trust-badges');
      if (badgesEl) {
        let nextEl = badgesEl.nextElementSibling;
        while (nextEl) {
          const toRemove = nextEl;
          nextEl = nextEl.nextElementSibling;
          toRemove.remove();
        }
      }
    }
  });  
}
